<div class="no-items-txt">
  {{message | translate}}
</div>
